// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { useSyncDocumentTheme } from '../../shared/theme';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';
import AdminCenterRoutes from '../routes/AdminCenterRoutes';
import '../theme/admin-theme.css';
import '../theme/admin-carbon.css';
import styles from './AdminCenterShell.module.css';

/**
 * Admin Center's own chrome — deliberately not nested inside Helios'
 * `AppShell` (no HeliosHeader/IconRail). `App.tsx` picks one shell or the
 * other based on the route, the same split a Module Federation host would
 * make between mounting its own shell vs. a remote's (ADR-0014 Phase 2).
 */
export default function AdminCenterShell() {
  // `data-carbon-theme` lives on <html>, shared with Helios — but Helios only
  // sets it from inside AppShell, which never mounts for /admin-center. Set
  // it here too, or a direct load of this route renders with every
  // `admin-theme.css` override silently unmatched (see useSyncDocumentTheme).
  useSyncDocumentTheme();

  return (
    // `admin-center-root` is a stable (non-hashed) hook admin-theme.css scopes
    // its palette overrides to. Also doubles as the floating-menu portal
    // target (Carbon's `OverflowMenu` looks for the nearest
    // `[data-floating-menu-container]` ancestor, else portals to
    // `document.body` — outside this scope, so its menu never sees the
    // navy palette). Deliberately placed HERE and not on a page's own root:
    // this element never scrolls (`.content` below does), so an absolutely
    // positioned menu appended into it can't inflate a scrolling ancestor's
    // content box into a second scrollbar the way it would one level down.
    <div className={`${styles.shell} admin-center-root`} data-floating-menu-container>
      <AdminHeader />
      <div className={styles.body}>
        <AdminSidebar />
        <main className={styles.content}>
          <AdminCenterRoutes />
        </main>
      </div>
    </div>
  );
}
